import apiRoutes from "../../utils/constants/apiRoutes";
import ApiService from "../apiService";
import handleApiCall from "../handleApi";

export const learnerAnalyticsService = async (query?: any) =>
  handleApiCall(() =>
    ApiService.get(
      !query
        ? apiRoutes.learnerAnalytics
        : apiRoutes.learnerAnalyticsById.replace("query", query)
    )
  );
